export enum SurveyStorageKeys {
    OmitSurvey = "SURVEY_OMITED_ON_THIS_SESSION",
    Transactions = "SURVEY_TRANSACTIONS",
    AnswerSurvey = "SURVEY_ANSWERED",
}
